import { render, staticRenderFns } from "./PwaPromoDialog.vue?vue&type=template&id=e3c2ce8c&scoped=true"
import script from "./PwaPromoDialog.vue?vue&type=script&lang=js"
export * from "./PwaPromoDialog.vue?vue&type=script&lang=js"
import style0 from "./PwaPromoDialog.vue?vue&type=style&index=0&id=e3c2ce8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c2ce8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3c2ce8c')) {
      api.createRecord('e3c2ce8c', component.options)
    } else {
      api.reload('e3c2ce8c', component.options)
    }
    module.hot.accept("./PwaPromoDialog.vue?vue&type=template&id=e3c2ce8c&scoped=true", function () {
      api.rerender('e3c2ce8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/PwaPromoDialog.vue"
export default component.exports